export default __webpack_public_path__ + "static/media/mindtickle-logo-orange.008b5184.svg";